import {
    actionTypes
} from '../constants/actionTypes';

const initialState = {
    results: [],
    connectionsListPerSelectedLocation: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.getConnectionsAvailabilityPerLocation:
            return {
                ...state,
                results: action.payload
            };
        case actionTypes.getConnectionsListPerLocation:
            return {
                ...state,
                connectionsListPerSelectedLocation: action.payload
            };
        default:
            return state;
    }
}
